import React, { useState, useEffect, useReducer, useRef } from "react";
import { v4 as uuidv4 } from "uuid";
import { Tooltip } from "devextreme-react/tooltip";
import { TextArea, TextBox } from "devextreme-react";
import ScrollView from "devextreme-react/scroll-view";
import { alert } from "devextreme/ui/dialog";

const Fishbone = ({
  fishBoneData,
  setFishBoneData,
  theRpsId,
  fishBoneDes,
  setfishBoneDes,
}) => {
  const handleEditClick = (index, item1, lst) => {
    setFishBoneData((prevItems) => {
      return prevItems.map((item) => {
        if (item.type === lst.type) {
          const updatedSubItems = item.lsCause.map((subItem) => {
            if (subItem.id === item1.id) {
              return { ...subItem, editMode: true };
            }
            return subItem;
          });
          return { ...item, lsCause: updatedSubItems };
        }
        return item;
      });
    });
  };

  const handleInputChangeEdit = (item2, item1, lst) => {
    setFishBoneData((prevItems) => {
      return prevItems.map((item) => {
        if (item.type === lst.type) {
          const updatedSubItems = item.lsCause.map((subItem) => {
            if (subItem.id === item2.id) {
              return { ...subItem, value: item1.target.value };
            }
            return subItem;
          });
          return { ...item, lsCause: updatedSubItems };
        }
        return item;
      });
    });
  };

  const handleInputBlur = (index, item1, lst) => {
    setFishBoneData((prevItems) => {
      return prevItems.map((item) => {
        if (item.type === lst.type) {
          const updatedSubItems = item.lsCause.map((subItem) => {
            if (subItem.id === item1.id) {
              return { ...subItem, editMode: false };
            }
            return subItem;
          });
          return { ...item, lsCause: updatedSubItems };
        }
        return item;
      });
    });
  };

  const handleInputKeyUp = (index, item1, lst, e) => {
    if (e.key === "Enter" || e.key === "Escape") {
      handleInputBlur(index, item1, lst);
    }
  };

  const handleAddButtonClick = (valueClicked, index) => {
    if (
      fishBoneDes !== null &&
      fishBoneDes !== undefined &&
      fishBoneDes !== "" &&
      fishBoneDes.length > 0
    ) {
      let newCause = {
        id: uuidv4(),
        value: "",
        isRCA: false,
        editMode: false,
        rcaId: 0,
      };
      // Find the item by its type
      const updatedItems = fishBoneData.map((item) => {
        if (item.type === valueClicked.type) {
          // Create a new object with the updated subItems array
          return {
            ...item,
            lsCause: [...item.lsCause, newCause],
          };
        }
        return item; // Return unchanged items
      });

      setFishBoneData([...updatedItems]);
    } else {
      alert("Please enter Description", "Alert");
      return;
    }
  };

  const handleRemoveButtonClick = (index, item1, lst) => {
    let updatedItems = [...fishBoneData];
    updatedItems.forEach((obj) => {
      const indexToDelete = obj.lsCause.findIndex(
        (item) => item.id === item1.id
      );
      if (indexToDelete !== -1) {
        obj.lsCause.splice(indexToDelete, 1);
      }
    });
    setFishBoneData(updatedItems);
  };
  const handleInputChange = (e) => {
    setfishBoneDes(e.value);
  };
  const marginval = (e, index1) => {
    if (index1 < 3) {
      return e * 15 + "px";
    } else if (index1 == 5) {
      if (e < 3) return -(e * 15) + 30 + "px";
    } else {
      if (e < 3) return -(e * 15) + 40 + "px";
    }
  };
  const renderContent = (data) => {
    return <p>{data}</p>;
  };

  return (
    <div>
      {/* fishbone */}

      <div style={{ display: "inline-block" }}>
        <div className="line-vertical-top" style={{ left: "325px" }}></div>
        <div className="line-vertical-top" style={{ left: "700px" }}></div>
        <div className="line-vertical-top" style={{ left: "1075px" }}></div>
      </div>
      <div className="line-horizontal arrow-right"></div>

      <div style={{ display: "inline-block" }}>
        <div className="line-vertical" style={{ left: "325px" }}></div>
        <div className="line-vertical" style={{ left: "700px" }}></div>
        <div className="line-vertical" style={{ left: "1075px" }}></div>
      </div>
      <div className="fishbonedescription">
        <TextArea
          label="Description"
          width={150}
          height={200}
          value={fishBoneDes}
          wordWrapEnabled={true}
          onValueChanged={(e) => handleInputChange(e)}
        ></TextArea>
      </div>
      {/* Cotent section of fishbone */}
      {fishBoneData?.map((item1, index1) => (
        <div className={`Fishbonecontent fish${index1}`}>
          <span className={`fishboneheader fishboneheader${index1}`}>
            {item1.type}
          </span>
          <div>
            <button
              key={index1}
              className={`fishadd${index1}`}
              onClick={() => handleAddButtonClick(item1, index1)}
            >
              {" "}
              <i
                title="Delete"
                className={`fas fa-plus`}
                style={{ marginRight: "2px" }}
              ></i>
              Add
            </button>
          </div>
          {/* <ScrollView
            width="100%"
            // height="270px"
            showScrollbar="always"
            scrollByContent="true"
            scrollByThumb="true"
          > */}
          <div className={`editsection editsection${index1}`}>
            {item1?.lsCause?.map((item, index) => (
              <div
                key={index}
                style={{
                  width: "300px",
                  marginLeft: marginval(index, index1),
                }}
              >
                {item?.editMode ? (
                  <textarea
                    type="text"
                    value={item.value}
                    onChange={(e) => handleInputChangeEdit(item, e, item1)}
                    onBlur={() => handleInputBlur(index, item, item1)}
                    onKeyUp={(e) => handleInputKeyUp(index, item, item1, e)}
                    autoFocus
                  />
                ) : (
                  <>
                    {" "}
                    <div className="causeContent">
                      <div className="tooltip">
                        {item?.value.length > 40
                          ? `${item?.value.substring(0, 40)}...`
                          : item?.value}
                        <span className="tooltiptext">{item?.value}</span>
                      </div>

                      <div style={{ display: "flow-root" }}>
                        {" "}
                        <i
                          onClick={() =>
                            handleRemoveButtonClick(index, item, item1)
                          }
                          class="fishboneIcon fa fa-trash"
                        ></i>
                        <i
                          onClick={(e) => handleEditClick(index, item, item1)}
                          class="fishboneIcon fa fa-edit"
                        ></i>
                      </div>
                      {/* <Tooltip
                      enabled={true}
                      shared={true}
                      contentRender={renderContent(item?.value)}
                    /> */}
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
          {/* </ScrollView> */}
        </div>
      ))}
    </div>
  );
};

export default Fishbone;
